module.exports = __webpack_public_path__ + "img/terms_conditions_icon.c29e73a2.svg";